import { pick, prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { setCUBalance } from '@theme/js/hooks/user/store/actions';
import { useUserSelector, useAppSelector } from '@core/js/store/hooks';
import { useGetTemporaryAuthenticationToken } from '@core/js/hooks/auth';
import { fetchSignedUserToken, getCaptainUpUserData } from '@theme/js/hooks/user/server';

import * as helpers from '../helpers';

export const useCaptainUpBalance = () => {
  const dispatch = useDispatch();
  const dynamicTags = useAppSelector(prop('dynamicTags'));
  const [isSDKInitialized, setIsSDKInitialized] = useState(false);
  const getTemporaryAuthenticationToken = useGetTemporaryAuthenticationToken();
  const { isLoggedIn, userDetails } = useUserSelector(
    pick(['isLoggedIn', 'userDetails'])
  );

  useEffect(() => {
    const { userId, username } = userDetails;
    const apiKey = dynamicTags?.DTAG_CU_API_KEY;
    const clientToken = dynamicTags?.DTAG_CU_CLIENT_TOKEN;
    const reqData = {
      userId,
      apiKey,
      username,
      clientToken
    };

    const initializeCaptainUp = async () => {
      await helpers.addCaptainUpScript();
      try {
        if (!apiKey || !clientToken) {
          console.error('Missing required data for Captain Up balance fetch');
          return;
        }
        if (!isLoggedIn) {
          console.error('Missing user logged in!');
          return;
        }

        const token = await getTemporaryAuthenticationToken();
        const signedUserToken = await fetchSignedUserToken(reqData, token);
        const { data } = await getCaptainUpUserData(reqData, signedUserToken);
        const coins = data?.currencies?.coins?.toString();

        if (coins) {
          dispatch(setCUBalance(coins));
        }

        if (window.captain && !isSDKInitialized) {
          try {
            const config = {
              // eslint-disable-next-line camelcase
              api_key: apiKey,
              // eslint-disable-next-line camelcase
              client_token: clientToken,
              // eslint-disable-next-line camelcase
              signed_user: signedUserToken,
              user: {
                id: userId,
                name: username
              }
            };

            window.captain.up(config).then(() => {
              window?.captain?.activities?.state?.subscribe((activities) => {
                const playerTotal = activities.find(item => item.name === 'currencies')?.currencies.coins.player_total.toString();
                if (playerTotal) {
                  dispatch(setCUBalance(playerTotal));
                }
              });
            });

            setIsSDKInitialized(true);
          } catch (error) {
            console.error('Failed to initialize Captain Up:', error);
          }
        }
      } catch (error) {
        console.error('Failed to fetch Captain Up balance:', error);
      }
    };

    initializeCaptainUp();
  }, [dispatch, isLoggedIn, userDetails, isSDKInitialized, dynamicTags, getTemporaryAuthenticationToken]);
};
